import React, { useEffect, useState } from "react";
import { TOOLTIP_COLORS } from "../../../styles/Variables";
import {
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ThemeMenuProps } from "../../../styles/AccordionStyles";
import { CustomTooltip } from "../../../styles/TooltipStyles";

const Skins = () => {
  const colorOption = [

    {
      label: "Blue",
      value: "blue",
      bgcolor: TOOLTIP_COLORS.BLUE,
    },
    {
      label: "Sky-Blue",
      value: "sky",
      bgcolor: TOOLTIP_COLORS.SKY,
    },
 
    {
      label: "Green",
      value: "Green",
      bgcolor: TOOLTIP_COLORS.GREEN,
    },
    {
      label: "Teal",
      value: "teal",
      bgcolor: TOOLTIP_COLORS.TEAL,
    },



    {
      label: "Purple",
      value: "purple",
      bgcolor: TOOLTIP_COLORS.PURPLE,
    },
    {
      label: "Pink",
      value: "pink",
      bgcolor: TOOLTIP_COLORS.PINK,
    },

    {
      label: "Lime",
      value: "lime",
      bgcolor: TOOLTIP_COLORS.LIME,
    },


    {
      label: "Fuchsia",
      value: "fuchsia",
      bgcolor: TOOLTIP_COLORS.FUCHSIA,
    },

    {
      label: "Grey",
      value: "grey",
      bgcolor: TOOLTIP_COLORS.GREY,
    },

    {
      label: "Amber",
      value: "amber",
      bgcolor: TOOLTIP_COLORS.AMBER,
    },
  ];

  const [theme, setTheme] = useState("");
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.className = savedTheme;
    }
  }, []);

  const handleThemeChange = (event: SelectChangeEvent) => {
    const selectedTheme = event.target.value;
    setTheme(selectedTheme);
    localStorage.setItem("theme", selectedTheme);
    document.documentElement.className = selectedTheme;
  };

  return (
    <>
      <Select
        onChange={handleThemeChange}
        className="theme-option"
        value={theme}
        MenuProps={ThemeMenuProps}
      >
        {colorOption.map((option, index: React.Key) => (
          <MenuItem key={index} value={option.value} className="theme-menu">
            <ListItemText>
              <CustomTooltip
                title={option.label}
                arrow
                placement="bottom"
                className="tooltip-hide"
                slotProps={{
                  tooltip: {
                    sx: {
                      bgcolor: option.bgcolor,
                      "& .MuiTooltip-arrow": {
                        color: option.bgcolor,
                      },
                    },
                  },
                }}
              >
                <span
                  style={{
                    backgroundColor: option.bgcolor,
                    width: 25,
                    height: 25,
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                />
              </CustomTooltip>
            </ListItemText>
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default Skins;
